import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type { IGetInvoicesFilterParams } from "../getInvoices/getInvoicesRequest.schema";
import type { TGetInvoiceStatsResponse } from "./getInvoiceStatsRequest.schema";

/**
 * Fetches aggregate stats (open, overdue, paid counts and amounts) for invoices
 * using the same filters as the invoice list. Use for dashboard cards.
 */
export const getInvoiceStats =
  (axios: IAxiosInstance) =>
  async (
    companyID: string,
    search: string = "",
    filterParams?: IGetInvoicesFilterParams
  ): Promise<TGetInvoiceStatsResponse> => {
    const params: Record<string, string> = { companyID, search: search ?? "" };
    if (filterParams) {
      if (filterParams.status) params.status = filterParams.status;
      if (filterParams.payment_status)
        params.payment_status = filterParams.payment_status;
      if (filterParams.invoiceDateFrom)
        params.invoiceDateFrom = filterParams.invoiceDateFrom;
      if (filterParams.invoiceDateTo)
        params.invoiceDateTo = filterParams.invoiceDateTo;
      if (filterParams.dueDateFrom)
        params.dueDateFrom = filterParams.dueDateFrom;
      if (filterParams.dueDateTo) params.dueDateTo = filterParams.dueDateTo;
    }

    const response = await axios.noRetry.get<
      | TGetInvoiceStatsResponse
      | {
          data: TGetInvoiceStatsResponse;
          success?: boolean;
          testMode?: boolean;
        }
    >("/api/invoices/stats", { params });
    const resData = response.data;
    if (resData && typeof resData === "object" && "error" in resData) {
      throw new Error(
        (resData as { error?: string }).error ?? "Error fetching invoice stats"
      );
    }
    const wrapped = resData as { data?: TGetInvoiceStatsResponse };
    return (
      wrapped?.data != null ? wrapped.data : resData
    ) as TGetInvoiceStatsResponse;
  };
